<template>
  <div class="container-fluid">
    <v-toolbar dense
               src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
    ></v-toolbar>
    <br>
    <v-container fluid>
      <v-row>
        <v-col cols="6">
          <v-card>
            <v-card-title class="d-block">
              <div class="d-flex">
                Celkem rozvozů:
                <span class="ml-3">{{this.expedition.total}}</span>
              </div>
              <div class="d-flex">
                Zbývá doručit:
                <span class="ml-3">{{this.expedition.notDelivered}}</span>
              </div>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <div class="row mt-4 mr-2 ml-2">
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <v-card
          elevation="3"
          class="mx-auto"
        >
          <v-row>
            <v-col>
              <v-card-text class="pt-0 mb-2">
                <div class="title font-weight-light mb-2">Nové registrace</div>
                <div class="subheading font-weight-light grey--text">Dnes</div>
              </v-card-text>
            </v-col>
          </v-row>
          <v-sheet
            class="v-sheet--offset mx-auto"
            elevation="0"
          >
            <NewRegistrationsGraph
            />
          </v-sheet>
        </v-card>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <AdjustableChart
            title="Objednávky"
            source-url="/admin/graph/orders"
            :meals="meals"
            :users="users"
          ></AdjustableChart>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <AdjustableChart
          title="Porce dnes"
          source-url="/admin/graph/serving-today"
          :meals="meals"
          :users="users"
        ></AdjustableChart>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <AdjustableChart
          title="Denní obrat"
          source-url="/admin/graph/daily-turnover"
          :meals="meals"
          :users="users"
        ></AdjustableChart>
      </div>
    </div>
  </div>
</template>

<script>
import NewRegistrationsGraph from '../../components/admin/charts/NewRegistrationsGraph'
import AdjustableChart from '../../components/admin/charts/AdjustableChart'
export default {
  name: 'Dashboard',
  components: { AdjustableChart, NewRegistrationsGraph },
  data () {
    return {
      users: [],
      meals: [],
      expedition: [],
      date: new Date().toISOString().substr(0, 10)
    }
  },
  methods: {
    initialize () {
      this.users = []
      this.meals = []
      this.$http.get('/admin/foods')
        .then(response => {
          this.meals = this.meals
            .concat(this.keysToCamelCase(response.data)
              .map(item => { item.type = 'App\\Food'; return item }))
            .filter(item => item.active)
        })
        .catch(err => { console.log(err) })
      this.$http.get('/admin/drinks')
        .then(response => {
          this.meals = this.meals
            .concat(this.keysToCamelCase(response.data)
              .map(item => { item.type = 'App\\Drink'; return item }))
            .filter(item => item.active)
        })
        .catch(err => { console.log(err) })
      this.$http.get('/admin/menus')
        .then(response => {
          this.meals = this.meals
            .concat(this.keysToCamelCase(response.data)
              .map(item => { item.type = 'App\\Menu'; return item }))
            .filter(item => item.active)
        })
        .catch(err => { console.log(err) })
      this.$http.get('/admin/roles/6')
        .then(response => {
          this.users = this.keysToCamelCase(response.data)
            .map(user => {
              user.fullName = `${user.firstName} ${user.lastName}`
              return user
            })
            .concat(this.users)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get(`/admin/overview/expedition/${this.date}`)
        .then(response => {
          this.expedition = this.keysToCamelCase(response.data)
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
</style>
